import React from "react";
import moment from "moment";
import { useNavigate, Link } from "react-router-dom";
import CountUp from "react-countup";
import { toast } from "react-hot-toast";
import { TailwindToaster } from "../components";
import { useSelector, useDispatch } from "react-redux";
import { format } from "date-fns";
import FileDownload from "js-file-download";
import { downloadBlobFile, uploadBlobToContainer } from "../api/azure";
import { logout } from "../redux/Actions/Actions";

import axios from "../api/axios";

const Dashboard = () => {
  const dashboardUrl = "/user/dashboard";
  const serviceCommentsUrl = "/servicecomment";
  const blobContainerName = "serviceticketattachments";

  const renderTags = (tags) => {
    if (tags) {
      const tagsArray = tags.split(" ");
      var returnText = "";
      tagsArray.forEach((element) => {
        returnText += "#" + element + " ";
      });
      return returnText.trim();
    } else {
      return "";
    }
  };
  const renderStatus = (status) => {
    switch (status) {
      case "NEW":
        return (
          <span className='bg-blue-100 text-blue-800 text-xs font-semibold px-1.5 py-0.5 rounded dark:bg-blue-200 dark:text-blue-800'>
            NEW
          </span>
        );
      case "ASSIGNED":
        return (
          <span className='bg-orange-100 text-orange-800 text-xs font-semibold px-1.5 py-0.5 rounded dark:bg-orange-200 dark:text-orange-900'>
            ASSIGNED
          </span>
        );
      case "IN-PROCESS":
        return (
          <span className='bg-green-100 text-green-800 text-xs font-semibold px-1.5 py-0.5 rounded dark:bg-green-200 dark:text-green-900'>
            IN-PROCESS
          </span>
        );
      case "DONE":
        return (
          <span className='bg-green-100 text-green-800 text-xs font-semibold px-1.5 py-0.5 rounded dark:bg-green-200 dark:text-green-900'>
            DONE
          </span>
        );
      default:
        return (
          <span className='bg-red-100 text-red-600 text-xs font-semibold px-1.5 py-0.5 rounded dark:bg-red-200 dark:text-red-900'>
            {status}
          </span>
        );
    }
  };

  const [downloadBlobFileName, setDownloadBlobFile] = React.useState(null);
  const downloadAttachment = async (
    blobContainer,
    blobName,
    originalname,
    mimetype,
  ) => {
    try {
      setDownloadBlobFile(blobName);
      const azureDownloadresult = await downloadBlobFile(
        blobContainer,
        blobName,
        originalname,
      );
      if (azureDownloadresult.status === "success") {
        const azureData = azureDownloadresult.data;
        const downloadFileUrl = window.URL.createObjectURL(azureData);
        const temporaryDownloadLink = document.createElement("a");
        temporaryDownloadLink.href = downloadFileUrl;
        temporaryDownloadLink.setAttribute("download", originalname);
        temporaryDownloadLink.click();
      } else {
        toast.error("Something went wrong with file download");
      }
      setDownloadBlobFile(null);
    } catch (err) {
      toast.error("Something went wrong");
      console.log(err);
    }
  };

  const [refreshData, setRefreshData] = React.useState(0);
  const [serviceTaskData, setServiceTaskData] = React.useState([]);
  const [recentActivityData, setRecentActivityData] = React.useState([]);
  const [statsData, setStatsData] = React.useState([]);
  const [activeServiceStats, setActiveServiceStats] = React.useState([]);
  const state = useSelector((state) => state.UserReducer);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const getDashboardData = (query) => {
    try {
      axios
        .get(dashboardUrl, {
          headers: {
            "Content-Type": "application/json",
            Authorization: state.user.token,
            "Access-Control-Allow-Origin": "*",
          },
        })
        .then((response) => {
          if (response?.data?.serviceTask?.length >= 0) {
            setServiceTaskData(response.data.serviceTask);
            setRecentActivityData(response.data.recentActivity);
            setStatsData(response.data.stats);
            setRefreshData(1);
          }
          if (response?.data?.serviceTypeStats?.length > 0) {
            const tempStats = [];
            response?.data?.serviceTypeStats.map((item) => {
              tempStats.push({
                name: item._id.name,
                count: item.count,
              });
            });
            setActiveServiceStats(tempStats);
          }
        })
        .catch((err) => {
          if (err.toString().includes("status code 401")) {
            dispatch(logout(state));
            localStorage.removeItem("63cea11a56a16759beca56461fe85621");
            localStorage.clear();
            navigate("/login");
          } else toast.error("Something went wrong");
          setRefreshData(1);
        });
    } catch (err) {
      toast.error("Something went wrong");
      setRefreshData(1);
    } finally {
      // setRefreshData(1);
    }
  };

  const [activeService, setActiveService] = React.useState(0);
  const [followUpService, setFollowUpService] = React.useState(0);
  const [holdService, setHoldService] = React.useState(0);
  const [activeEnquiries, setActiveEnquiries] = React.useState(0);
  const [holdEnquiries, setHoldEnquiries] = React.useState(0);
  const [customerServices, setCustomerService] = React.useState(0);
  const [customerEnquiry, setCustomerEnquiry] = React.useState(0);
  const [crmServices, setCRMService] = React.useState(0);
  const [crmEnquiry, setCRMEnquiry] = React.useState(0);
  React.useEffect(() => {
    if (statsData?.serviceStats?.length > 0) {
      setFollowUpService(statsData?.serviceStats[0]?.count);
      setActiveService(statsData?.serviceStats[1]?.count);
      setHoldService(statsData?.serviceStats[2]?.count);
    }

    if (statsData?.enquiryStats?.length > 0) {
      var activeEnquiry = 0;
      var holdEnquiry = 0;
      statsData.enquiryStats.map((item) => {
        if (item._id === "HOLD") holdEnquiry += item.count;
        else activeEnquiry += item.count;
      });
      setActiveEnquiries(activeEnquiry);
      setHoldEnquiries(holdEnquiry);
    }
    setCustomerService(statsData?.customerServiceStat);
    setCustomerEnquiry(statsData?.customerEnquiryStat);
    setCRMService(statsData?.crmServiceStat);
    setCRMEnquiry(statsData?.crmEnquiryStat);
  }, [statsData]);

  const [pageTitle, setPageTitle] = React.useState("Lands & Lands ERP");
  React.useEffect(() => {
    document.title = pageTitle;
  }, [pageTitle]);

  React.useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
    getDashboardData("");
    setPageTitle("Dashboard - L&L ERP Dashboard");
  }, []);

  return (
    <>
      <TailwindToaster />
      <div className='min-h-full bg-gray-50'>
        <main className='relative'>
          <div className='max-w-8xl mx-auto py-6 sm:px-6 lg:px-8'>
            <div className='lg:flex lg:items-center justify-between'>
              <div className='flex-1 min-w-0 px-5 lg:px-0'>
                <h2 className='mt-4 ml-1 text-md font-semibold leading-3 text-gray-dark sm:text-lg'>
                  Welcome Back, {state.user.firstName}
                </h2>
              </div>
            </div>
            <div className='px-4 py-6 sm:px-0 w-full'>
              <div className='hidden sm:block flex-col'>
                <div className='flex justify-center space-x-5 ml-4'>
                  <div
                    className='shadow-lg rounded-lg hover:bg-gray-100 duration-300 bg-white px-3 pb-2 pt-1 cursor-default'
                    onClick={(e) => {
                      navigate("/serviceticket");
                    }}>
                    <div className='flex-col p-2 pr-5'>
                      <span className='font-semibold text-sm'>Service</span>
                      <div className='flex mt-1 ml-3'>
                        <div className='flex-col border-r-2 border-gray-100 pr-5'>
                          <div className='w-full'>
                            {refreshData > 0 ? (
                              <span className='text-2xl font-bold text-service-dashboard'>
                                <CountUp end={activeService} duration={0.75} />
                              </span>
                            ) : (
                              <div className='flex animate-pulse flex-row items-center h-full justify-center'>
                                <div className='w-8 bg-gray-100 h-8 rounded-md '></div>
                              </div>
                            )}
                          </div>
                          <div className='w-full -mt-1'>
                            <span className='text-xs font-semibold text-gray-700'>
                              Active
                            </span>
                          </div>
                        </div>
                        <div className='flex-col border-r-2 border-gray-100 ml-4 pr-5'>
                          <div className='w-full'>
                            {refreshData > 0 ? (
                              <span className='text-2xl font-bold text-service-dashboard'>
                                <CountUp end={followUpService} duration={0.5} />
                              </span>
                            ) : (
                              <div className='flex animate-pulse flex-row items-center h-full justify-center'>
                                <div className='w-8 bg-gray-100 h-8 rounded-md '></div>
                              </div>
                            )}
                          </div>
                          <div className='w-full -mt-1'>
                            <span className='text-xs font-semibold text-gray-700'>
                              Follow Up
                            </span>
                          </div>
                        </div>
                        <div className='flex-col ml-4'>
                          <div className='w-full'>
                            {refreshData > 0 ? (
                              <span className='text-2xl font-bold text-service-dashboard'>
                                <CountUp end={holdService} duration={0.5} />
                              </span>
                            ) : (
                              <div className='flex animate-pulse flex-row items-center h-full justify-center'>
                                <div className='w-8 bg-gray-100 h-8 rounded-md '></div>
                              </div>
                            )}
                          </div>
                          <div className='w-full -mt-1'>
                            <span className='text-xs font-semibold text-gray-700'>
                              Hold
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    className='shadow-lg rounded-lg hover:bg-gray-100 duration-300 bg-white px-3 pb-2 pt-1 cursor-default'
                    onClick={(e) => {
                      navigate("/enquiry");
                    }}>
                    <div className='flex-col p-2 pr-5'>
                      <span className='font-semibold text-sm'>Enquiry</span>
                      <div className='flex mt-1 ml-3'>
                        <div className='flex-col border-r-2 border-gray-100 pr-5'>
                          <div className='w-full'>
                            {refreshData > 0 ? (
                              <span className='text-2xl font-bold text-enquiry-dashboard'>
                                <CountUp
                                  end={activeEnquiries}
                                  duration={0.75}
                                />
                              </span>
                            ) : (
                              <div className='flex animate-pulse flex-row items-center h-full justify-center'>
                                <div className='w-8 bg-gray-100 h-8 rounded-md '></div>
                              </div>
                            )}
                          </div>
                          <div className='w-full -mt-1'>
                            <span className='text-xs font-semibold text-gray-700'>
                              Active
                            </span>
                          </div>
                        </div>
                        <div className='flex-col ml-4'>
                          <div className='w-full'>
                            {refreshData > 0 ? (
                              <span className='text-2xl font-bold text-enquiry-dashboard'>
                                <CountUp end={holdEnquiries} duration={0.5} />
                              </span>
                            ) : (
                              <div className='flex animate-pulse flex-row items-center h-full justify-center'>
                                <div className='w-8 bg-gray-100 h-8 rounded-md '></div>
                              </div>
                            )}
                          </div>
                          <div className='w-full -mt-1'>
                            <span className='text-xs font-semibold text-gray-700'>
                              Hold
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    className='shadow-lg rounded-lg hover:bg-gray-100 duration-300 bg-white px-3 pb-2 pt-1 cursor-default'
                    onClick={(e) => {
                      navigate("/addressbook");
                    }}>
                    <div className='flex-col p-2 pr-5'>
                      <span className='font-semibold text-sm'>Customer</span>
                      <div className='flex mt-1 ml-3'>
                        <div className='flex-col border-r-2 border-gray-100 pr-5'>
                          <div className='w-full'>
                            {refreshData > 0 ? (
                              <span className='text-2xl font-bold text-customer-dashboard'>
                                <CountUp
                                  end={customerServices}
                                  duration={0.75}
                                />
                              </span>
                            ) : (
                              <div className='flex animate-pulse flex-row items-center h-full justify-center'>
                                <div className='w-8 bg-gray-100 h-8 rounded-md '></div>
                              </div>
                            )}
                          </div>
                          <div className='w-full -mt-1'>
                            <span className='text-xs font-semibold text-gray-700'>
                              Service
                            </span>
                          </div>
                        </div>
                        <div className='flex-col ml-4'>
                          <div className='w-full'>
                            {refreshData > 0 ? (
                              <span className='text-2xl font-bold text-customer-dashboard'>
                                <CountUp end={customerEnquiry} duration={0.5} />
                              </span>
                            ) : (
                              <div className='flex animate-pulse flex-row items-center h-full justify-center'>
                                <div className='w-8 bg-gray-100 h-8 rounded-md '></div>
                              </div>
                            )}
                          </div>
                          <div className='w-full -mt-1'>
                            <span className='text-xs font-semibold text-gray-700'>
                              Enquiry
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    className='shadow-lg rounded-lg hover:bg-gray-100 duration-300 bg-white px-3 pb-2 pt-1 cursor-default'
                    onClick={(e) => {
                      navigate("/addressbook");
                    }}>
                    <div className='flex-col p-2 pr-5'>
                      <span className='font-semibold text-sm'>CRM</span>
                      <div className='flex mt-1 ml-3'>
                        <div className='flex-col border-r-2 border-gray-100 pr-5'>
                          <div className='w-full'>
                            {refreshData > 0 ? (
                              <span className='text-2xl font-bold text-crm-dashboard'>
                                <CountUp end={crmServices} duration={0.75} />
                              </span>
                            ) : (
                              <div className='flex animate-pulse flex-row items-center h-full justify-center'>
                                <div className='w-8 bg-gray-100 h-8 rounded-md '></div>
                              </div>
                            )}
                          </div>
                          <div className='w-full -mt-1'>
                            <span className='text-xs font-semibold text-gray-700'>
                              Service
                            </span>
                          </div>
                        </div>
                        <div className='flex-col ml-4'>
                          <div className='w-full'>
                            {refreshData > 0 ? (
                              <span className='text-2xl font-bold text-crm-dashboard'>
                                <CountUp end={crmEnquiry} duration={0.5} />
                              </span>
                            ) : (
                              <div className='flex animate-pulse flex-row items-center h-full justify-center'>
                                <div className='w-8 bg-gray-100 h-8 rounded-md '></div>
                              </div>
                            )}
                          </div>
                          <div className='w-full -mt-1'>
                            <span className='text-xs font-semibold text-gray-700'>
                              Enquiry
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className='mt-8 flex flex-row gap-x-4'>
                  <div className='flex-col basis-1/5 border-r-2 border-gray-100'>
                    <div className=''>
                      <h2 className='ml-1 text-sm font-semibold leading-3 text-gray-dark sm:text-lg'>
                        Active Service Stats
                      </h2>
                    </div>
                    {activeServiceStats.length > 0 && (
                      <div className='pr-3 py-2 flex flex-col gap-y-2 border-0 text-gray-500 text-sm'>
                        {activeServiceStats.map((item) => (
                          <div className='flex justify-between font-medium hover:bg-yellow-100 hover:text-gray-700 rounded-sm py-1 px-3 cursor-default duration-300'>
                            <p>{item.name}</p>
                            <p>{item.count}</p>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                  <div className='flex-col basis-2/5 border-r-2 border-gray-100'>
                    <div className=''>
                      <h2 className='ml-1 text-sm font-semibold leading-3 text-gray-dark sm:text-lg'>
                        Tasks for you
                      </h2>
                    </div>
                    {refreshData > 0 ? (
                      serviceTaskData.length > 0 ? (
                        <div className='flex-col space-y-2 w-full px-4 mt-1'>
                          {serviceTaskData.map((item) => (
                            <div
                              key={item._id}
                              className='flex space-x-2 justify-between px-3 py-2 bg-white hover:bg-gray-300 duration-300 rounded-md hover:rounded-sm shadow-md overflow-x-auto'
                              onClick={(e) => {
                                navigate("/servicetask/" + item._id);
                              }}>
                              <div className=''>
                                <span className='font-semibold text-sm text-yellow-dark mr-2'>
                                  #{item.serviceTaskID}
                                </span>
                                <span className='font-semibold text-sm text-gray-dark cursor-default'>
                                  {item.name.slice(0, 50)}
                                </span>
                              </div>
                              <div className='flex justify-end font-semibold text-xs rounded-md text-gray-dark'>
                                <span className='mt-1'>
                                  {item.dueDate
                                    ?.toString()
                                    .slice(0, 16)
                                    .replace("T", " ")}
                                </span>
                                {moment(item?.dueDate.toString().slice(0, 19))
                                  // .local()
                                  .diff(Date.now(), "minutes") < 0 &&
                                  !item.status.includes(
                                    "DONE",
                                    "CANCELLED",
                                  ) && (
                                    <div className='font-semibold pl-2 animate-pulse rounded-md leading-5'>
                                      <span className='bg-red-100 text-red-200 text-xs font-semibold px-1.5 py-0.5 rounded dark:bg-red-800'>
                                        OVERDUE
                                      </span>
                                    </div>
                                  )}
                                <div className='ml-2 mt-0.5'>
                                  {renderStatus(item.status)}
                                </div>
                              </div>
                            </div>
                          ))}
                          <div className='flex justify-center'>
                            <Link
                              to='/servicetask'
                              className='text-sm mt-1 font-semibold text-yellow-dark py-2 px-3 hover:bg-gray-100 rounded-md cursor-pointer'>
                              View All
                            </Link>
                          </div>
                        </div>
                      ) : (
                        <div className='flex justify-center w-9/12'>
                          <h2 className='mt-4 text-md font-semibold leading-3 text-gray-dark'>
                            No tasks for you today. Have fun!!
                          </h2>
                        </div>
                      )
                    ) : (
                      <div className='flex-col animate-pulse items-center h-full justify-center w-10/12'>
                        <div className='w-full bg-gray-100 h-8 rounded-md my-2'></div>
                        <div className='w-full bg-gray-100 h-8 rounded-md my-2'></div>
                        <div className='w-full bg-gray-100 h-8 rounded-md my-2'></div>
                        <div className='w-full bg-gray-100 h-8 rounded-md my-2'></div>
                        <div className='w-full bg-gray-100 h-8 rounded-md my-2'></div>
                      </div>
                    )}
                  </div>
                  <div className='flex-col basis-2/5'>
                    <div className=''>
                      <h2 className='ml-1 text-sm font-semibold leading-3 text-gray-dark sm:text-lg'>
                        Recent Activity
                      </h2>
                    </div>
                    <div className=''>
                      {refreshData > 0 ? (
                        recentActivityData?.length > 0 ? (
                          <div className='grid grid-cols-1 gap-0 divide-y-2 divide-gray-100 bg-white rounded-sm shadow-lg border-gray-100'>
                            {recentActivityData.map((item) => (
                              <div
                                className='cursor-pointer w-full hover:shadow-lg hover:bg-gray-300 duration-300'
                                key={item._id}
                                onClick={(e) => {
                                  navigate(
                                    "/" +
                                      item?.indexName +
                                      "/" +
                                      item?.targetId,
                                  );
                                }}>
                                <div className=' pb-0 flex justify-start'>
                                  <div className='flex-row overflow-x-auto pl-2 pr-2 py-2 w-full duration-300'>
                                    <div className='flex justify-between'>
                                      <div className='text-xs font-semibold pb-0.25 text-blue-800 '>
                                        <p className='text-shadow'>
                                          {item.tags
                                            ? item.tags !== ""
                                              ? renderTags(item.tags)
                                              : renderTags(item.commentType)
                                            : "#user-comment"}
                                        </p>
                                      </div>
                                      <div className='text-xs font-semibold text-gray-700'>
                                        {format(
                                          new Date(item.updatedAt),
                                          "MMM dd yyyy, hh:mm a",
                                        )}
                                      </div>
                                    </div>
                                    <div
                                      className='text-xs mt-0.5'
                                      dangerouslySetInnerHTML={{
                                        __html: item.description,
                                      }}></div>
                                  </div>
                                </div>
                                <div className='flex'>
                                  {item.attachments?.length > 0 ? (
                                    item.attachments.map((item) => (
                                      <div
                                        key={item.blobName}
                                        className='ml-1.5 text-xs px-1.5 pt-0.5 pb-1 bg-yellow-50 rounded-md z-0 cursor-pointer'
                                        onClick={(e) => {
                                          downloadAttachment(
                                            item.blobContainer,
                                            item.blobName,
                                            item.originalname,
                                            item.mimetype,
                                          );
                                        }}>
                                        <div className='flex'>
                                          <div className='font-semibold text-yellow-dark'>
                                            {item.originalname}
                                          </div>
                                        </div>
                                      </div>
                                    ))
                                  ) : (
                                    <></>
                                  )}
                                </div>
                              </div>
                            ))}
                          </div>
                        ) : (
                          <div className='w-full grid justify-items-center font-semibold mt-4 text-sm'>
                            No Activity yet
                          </div>
                        )
                      ) : (
                        <div className='flex-col animate-pulse items-center h-full justify-center'>
                          <div className='w-full bg-gray-100 h-8 rounded-md my-2'></div>
                          <div className='w-full bg-gray-100 h-8 rounded-md my-2'></div>
                          <div className='w-full bg-gray-100 h-8 rounded-md my-2'></div>
                          <div className='w-full bg-gray-100 h-8 rounded-md my-2'></div>
                          <div className='w-full bg-gray-100 h-8 rounded-md my-2'></div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <div className='block sm:hidden flex-col px-2'>
                <div className='grid grid-cols-2 gap-x-5 gap-y-3'>
                  <div
                    className='shadow-lg rounded-lg hover:bg-gray-100 duration-300 bg-white px-3 pb-2 pt-1 cursor-default'
                    onClick={(e) => {
                      navigate("/serviceticket");
                    }}>
                    <div className='flex-col pr-5'>
                      <span className='font-semibold text-sm'>Service</span>
                      <div className='flex mt-1 ml-3'>
                        <div className='flex-col border-r-2 border-gray-100 pr-5'>
                          <div className='w-full'>
                            {refreshData > 0 ? (
                              <span className='text-xl font-bold text-service-dashboard'>
                                <CountUp end={activeService} duration={0.75} />
                              </span>
                            ) : (
                              <div className='flex animate-pulse flex-row items-center h-full justify-center'>
                                <div className='w-8 bg-gray-100 h-8 rounded-md '></div>
                              </div>
                            )}
                          </div>
                          <div className='w-full -mt-1'>
                            <span className='text-xs font-semibold text-gray-700'>
                              Active
                            </span>
                          </div>
                        </div>
                        <div className='flex-col ml-4'>
                          <div className='w-full'>
                            {refreshData > 0 ? (
                              <span className='text-xl font-bold text-service-dashboard'>
                                <CountUp end={holdService} duration={0.5} />
                              </span>
                            ) : (
                              <div className='flex animate-pulse flex-row items-center h-full justify-center'>
                                <div className='w-8 bg-gray-100 h-8 rounded-md '></div>
                              </div>
                            )}
                          </div>
                          <div className='w-full -mt-1'>
                            <span className='text-xs font-semibold text-gray-700'>
                              Hold
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    className='shadow-lg rounded-lg hover:bg-gray-100 duration-300 bg-white px-3 pb-2 pt-1 cursor-default'
                    onClick={(e) => {
                      navigate("/enquiry");
                    }}>
                    <div className='flex-col pr-5'>
                      <span className='font-semibold text-sm'>Enquiry</span>
                      <div className='flex mt-1 ml-3'>
                        <div className='flex-col border-r-2 border-gray-100 pr-5'>
                          <div className='w-full'>
                            {refreshData > 0 ? (
                              <span className='text-2xl font-bold text-enquiry-dashboard'>
                                <CountUp
                                  end={activeEnquiries}
                                  duration={0.75}
                                />
                              </span>
                            ) : (
                              <div className='flex animate-pulse flex-row items-center h-full justify-center'>
                                <div className='w-8 bg-gray-100 h-8 rounded-md '></div>
                              </div>
                            )}
                          </div>
                          <div className='w-full -mt-1'>
                            <span className='text-xs font-semibold text-gray-700'>
                              Active
                            </span>
                          </div>
                        </div>
                        <div className='flex-col ml-4'>
                          <div className='w-full'>
                            {refreshData > 0 ? (
                              <span className='text-2xl font-bold text-enquiry-dashboard'>
                                <CountUp end={holdEnquiries} duration={0.5} />
                              </span>
                            ) : (
                              <div className='flex animate-pulse flex-row items-center h-full justify-center'>
                                <div className='w-8 bg-gray-100 h-8 rounded-md '></div>
                              </div>
                            )}
                          </div>
                          <div className='w-full -mt-1'>
                            <span className='text-xs font-semibold text-gray-700'>
                              Hold
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    className='shadow-lg rounded-lg hover:bg-gray-100 duration-300 bg-white px-3 pb-2 pt-1 cursor-default'
                    onClick={(e) => {
                      navigate("/addressbook");
                    }}>
                    <div className='flex-col pr-5'>
                      <span className='font-semibold text-sm'>Customer</span>
                      <div className='flex mt-1 ml-3'>
                        <div className='flex-col border-r-2 border-gray-100 pr-5'>
                          <div className='w-full'>
                            {refreshData > 0 ? (
                              <span className='text-2xl font-bold text-customer-dashboard'>
                                <CountUp
                                  end={customerServices}
                                  duration={0.75}
                                />
                              </span>
                            ) : (
                              <div className='flex animate-pulse flex-row items-center h-full justify-center'>
                                <div className='w-8 bg-gray-100 h-8 rounded-md '></div>
                              </div>
                            )}
                          </div>
                          <div className='w-full -mt-1'>
                            <span className='text-xs font-semibold text-gray-700'>
                              Service
                            </span>
                          </div>
                        </div>
                        <div className='flex-col ml-4'>
                          <div className='w-full'>
                            {refreshData > 0 ? (
                              <span className='text-2xl font-bold text-customer-dashboard'>
                                <CountUp end={customerEnquiry} duration={0.5} />
                              </span>
                            ) : (
                              <div className='flex animate-pulse flex-row items-center h-full justify-center'>
                                <div className='w-8 bg-gray-100 h-8 rounded-md '></div>
                              </div>
                            )}
                          </div>
                          <div className='w-full -mt-1'>
                            <span className='text-xs font-semibold text-gray-700'>
                              Enquiry
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    className='shadow-lg rounded-lg hover:bg-gray-100 duration-300 bg-white px-3 pb-2 pt-1 cursor-default'
                    onClick={(e) => {
                      navigate("/addressbook");
                    }}>
                    <div className='flex-col pr-5'>
                      <span className='font-semibold text-sm'>CRM</span>
                      <div className='flex mt-1 ml-3'>
                        <div className='flex-col border-r-2 border-gray-100 pr-5'>
                          <div className='w-full'>
                            {refreshData > 0 ? (
                              <span className='text-2xl font-bold text-crm-dashboard'>
                                <CountUp end={crmServices} duration={0.75} />
                              </span>
                            ) : (
                              <div className='flex animate-pulse flex-row items-center h-full justify-center'>
                                <div className='w-8 bg-gray-100 h-8 rounded-md '></div>
                              </div>
                            )}
                          </div>
                          <div className='w-full -mt-1'>
                            <span className='text-xs font-semibold text-gray-700'>
                              Service
                            </span>
                          </div>
                        </div>
                        <div className='flex-col ml-4'>
                          <div className='w-full'>
                            {refreshData > 0 ? (
                              <span className='text-2xl font-bold text-crm-dashboard'>
                                <CountUp end={crmEnquiry} duration={0.5} />
                              </span>
                            ) : (
                              <div className='flex animate-pulse flex-row items-center h-full justify-center'>
                                <div className='w-8 bg-gray-100 h-8 rounded-md '></div>
                              </div>
                            )}
                          </div>
                          <div className='w-full -mt-1'>
                            <span className='text-xs font-semibold text-gray-700'>
                              Enquiry
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className='grid grid-cols-1 gap-3 mt-8'>
                  <h2 className='text-md font-semibold leading-3 text-gray-dark'>
                    Tasks for you
                  </h2>
                  {refreshData > 0 ? (
                    serviceTaskData.length > 0 ? (
                      <div className='grid grid-cols-1 border-2 border-gray-100 divide-y-2 divide-gray-100 rounded-sm shadow-lg'>
                        {serviceTaskData.map((item) => (
                          <div
                            className='flex-col px-2.5 py-1.5'
                            onClick={(e) => {
                              navigate("/servicetask/" + item._id);
                            }}>
                            <div className='flex justify-between'>
                              <span className='font-semibold text-sm text-yellow-dark'>
                                #{item.serviceTaskID}
                              </span>
                              <div className=''>
                                {renderStatus(item.status)}
                              </div>
                            </div>
                            <div className='font-semibold text-sm text-gray-dark cursor-default -mt-1'>
                              {item.name.slice(0, 50)}
                            </div>
                            <div className='font-semibold text-sm rounded-md text-gray-dark flex mb-0.5'>
                              <span>
                                {item.dueDate?.toString().slice(0, 10)}
                              </span>
                              {moment(item.dueDate.toString().slice(0, 19))
                                // .local()
                                .diff(Date.now(), "minutes") < 0 &&
                                !item.status.includes("DONE", "CANCELLED") && (
                                  <div className='font-semibold pl-2 animate-pulse rounded-md leading-5'>
                                    <span className='bg-red-100 text-red-200 text-xs font-semibold px-1.5 py-0.5 rounded dark:bg-red-800'>
                                      OVERDUE
                                    </span>
                                  </div>
                                )}
                            </div>
                          </div>
                        ))}
                        <div className='flex justify-center'>
                          <Link
                            to='/servicetask'
                            className='text-sm font-semibold text-yellow-dark py-2 px-3 hover:bg-gray-100 rounded-md cursor-pointer'>
                            View All
                          </Link>
                        </div>
                      </div>
                    ) : (
                      <div className='flex justify-center w-full'>
                        <h2 className='mt-2 text-md font-semibold leading-3 text-gray-dark'>
                          No tasks for you today. Have fun!!
                        </h2>
                      </div>
                    )
                  ) : (
                    <div className='flex-col animate-pulse items-center h-full justify-center'>
                      <div className='w-full bg-gray-100 h-8 rounded-md my-2'></div>
                      <div className='w-full bg-gray-100 h-8 rounded-md my-2'></div>
                      <div className='w-full bg-gray-100 h-8 rounded-md my-2'></div>
                      <div className='w-full bg-gray-100 h-8 rounded-md my-2'></div>
                      <div className='w-full bg-gray-100 h-8 rounded-md my-2'></div>
                    </div>
                  )}
                </div>
                <div className='grid grid-cols-1 gap-3 mt-8'>
                  <h2 className='text-md font-semibold leading-3 text-gray-dark'>
                    Recent Activity
                  </h2>
                  {refreshData > 0 ? (
                    recentActivityData?.length > 0 ? (
                      <div className='grid grid-cols-1 gap-0 divide-y-2 divide-gray-100 bg-white rounded-sm shadow-lg border-2 border-gray-100'>
                        {recentActivityData.map((item) => (
                          <div
                            className='cursor-pointer w-full hover:shadow-lg duration-300'
                            key={item._id}
                            onClick={(e) => {
                              navigate(
                                "/" + item?.indexName + "/" + item?.targetId,
                              );
                            }}>
                            <div className=' pb-0 flex justify-start'>
                              <div className='flex-row overflow-x-auto pl-2 pr-2 py-2 w-full duration-300'>
                                <div className='flex justify-between'>
                                  <div className='text-xs font-semibold pb-0.25 text-blue-800 '>
                                    <p className='text-shadow'>
                                      {item.tags
                                        ? item.tags !== ""
                                          ? renderTags(item.tags)
                                          : renderTags(item.commentType)
                                        : "#user-comment"}
                                    </p>
                                  </div>
                                  <div className='text-xs font-semibold text-gray-700'>
                                    {format(
                                      new Date(item.updatedAt),
                                      "MMM dd, hh:mm a",
                                    )}
                                  </div>
                                </div>

                                <div
                                  className='text-xs mt-0.5'
                                  dangerouslySetInnerHTML={{
                                    __html: item.description,
                                  }}></div>
                              </div>
                            </div>
                            <div className='flex'>
                              {item.attachments?.length > 0 ? (
                                item.attachments.map((item) => (
                                  <div
                                    key={item.blobName}
                                    className='ml-1.5 text-xs px-1.5 pt-0.5 pb-1 bg-yellow-50 rounded-md z-0 cursor-pointer'
                                    onClick={(e) => {
                                      downloadAttachment(
                                        item.blobContainer,
                                        item.blobName,
                                        item.originalname,
                                        item.mimetype,
                                      );
                                    }}>
                                    <div className='flex'>
                                      <div className='font-semibold text-yellow-dark'>
                                        {item.originalname}
                                      </div>
                                    </div>
                                  </div>
                                ))
                              ) : (
                                <></>
                              )}
                            </div>
                          </div>
                        ))}
                      </div>
                    ) : (
                      <div className='w-full grid justify-items-center font-semibold mt-4 text-sm'>
                        No Activity yet
                      </div>
                    )
                  ) : (
                    <div className='flex-col animate-pulse items-center h-full justify-center'>
                      <div className='w-full bg-gray-100 h-8 rounded-md my-2'></div>
                      <div className='w-full bg-gray-100 h-8 rounded-md my-2'></div>
                      <div className='w-full bg-gray-100 h-8 rounded-md my-2'></div>
                      <div className='w-full bg-gray-100 h-8 rounded-md my-2'></div>
                      <div className='w-full bg-gray-100 h-8 rounded-md my-2'></div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
    </>
  );
};

export default Dashboard;
